import React from 'react'
import { useNavigate } from 'react-router-dom'

export const AccessDeniedPage: React.FC = () => {
  const navigate = useNavigate()
  return (
    <div
      className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4"
      data-testid="access-denied-page"
    >
      <div className="max-w-md w-full bg-white dark:bg-gray-800 p-8 rounded-lg shadow text-center space-y-6">
        <div
          aria-hidden="true"
          className="w-16 h-16 mx-auto rounded-full bg-red-100 dark:bg-red-900/30 text-red-600 flex items-center justify-center text-3xl"
        >
          {/* Minimal lock glyph — no dependency on icon library. */}
          {'🔒'}
        </div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Akses Ditolak</h1>
        <p className="text-gray-600 dark:text-gray-300">
          Anda tidak punya akses ke fitur ini. Hubungi super admin untuk permintaan akses.
        </p>
        <button
          type="button"
          onClick={() => navigate('/dashboard')}
          className="px-4 py-2 bg-blue-600 text-white rounded-md"
          data-testid="back-to-dashboard"
        >
          Kembali ke Dashboard
        </button>
      </div>
    </div>
  )
}

export default AccessDeniedPage
